import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

export default function ShareScreen() {
  const { type, id } = useParams();
  const [loading, setLoading] = useState(true);
  const [appInstalled, setAppInstalled] = useState(false);

  const deepLink = `e24://${type}/${id}`;

  useEffect(() => {
    if (type && id) {
      const ua = navigator.userAgent.toLowerCase();
      const isAndroid = ua.includes("android");
      const isIOS = ua.includes("iphone") || ua.includes("ipad");

      // Meta tags dynamically нэмэх
      const head = document.head;
      const metaTags = [
        { property: "og:title", content: `Бүтээгдэхүүн: ${id}` },
        { property: "og:description", content: "Энэ бол миний бүтээгдэхүүн." },
        {
          property: "og:image",
          content: "https://store.erdenet24.mn/images/product123456.jpg",
        },
        { property: "og:url", content: window.location.href },
        { name: "twitter:card", content: "summary_large_image" },
      ];

      const createdTags = metaTags.map(({ property, name, content }) => {
        const tag = document.createElement("meta");
        if (property) tag.setAttribute("property", property);
        if (name) tag.setAttribute("name", name);
        tag.setAttribute("content", content);
        head.appendChild(tag);
        return tag;
      });

      let fallbackTimeout;
      let appCheckTimeout;

      function openApp() {
        const startTime = Date.now();

        // App суусан эсэхийг шалгах timeout
        appCheckTimeout = setTimeout(() => {
          // Хэрэглэгч апп руу шилжиагүй бол (хуудас орхиогүй бол) апп суугаагүй гэж үзнэ
          if (!appInstalled) {
            redirectToAppStore(isIOS, isAndroid);
          }
        }, 1000);

        // Deeplink нээх
        window.location.href = deepLink;

        // Android-д апп суугаагүй үед deeplink алдаа өгдөг тул шууд app store руу шилжих
        if (isAndroid) {
          fallbackTimeout = setTimeout(() => {
            // Хэрэглэгч апп руу шилжихгүй бол app store руу шилжих
            redirectToAppStore(isIOS, isAndroid);
          }, 500);
        }

        // iOS-д universal link ашиглах боломжтой
        if (isIOS) {
          // Universal link нээх
          window.open(`https://erdenet24.mn/app/${type}/${id}`, "_self");

          // Universal link ажиллахгүй бол deeplink руу буцах
          fallbackTimeout = setTimeout(() => {
            if (!appInstalled) {
              redirectToAppStore(isIOS, isAndroid);
            }
          }, 1000);
        }
      }

      function redirectToAppStore(ios, android) {
        setAppInstalled(false);
        if (ios) {
          window.location.href = "https://apps.apple.com/app/6444353401";
        } else if (android) {
          window.location.href =
            "https://play.google.com/store/apps/details?id=mn.et24";
        }
      }

      // Хэрэглэгч апп руу шилжсэн эсэхийг шалгах
      const handleVisibilityChange = () => {
        if (document.hidden || document.visibilityState === "hidden") {
          setAppInstalled(true);
          clearTimeout(fallbackTimeout);
          clearTimeout(appCheckTimeout);
        }
      };

      const handlePageHide = () => {
        setAppInstalled(true);
        clearTimeout(fallbackTimeout);
        clearTimeout(appCheckTimeout);
      };

      document.addEventListener("visibilitychange", handleVisibilityChange);
      document.addEventListener("pagehide", handlePageHide);

      openApp();

      const timer = setTimeout(() => setLoading(false), 2000);

      return () => {
        clearTimeout(timer);
        clearTimeout(fallbackTimeout);
        clearTimeout(appCheckTimeout);
        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange
        );
        document.removeEventListener("pagehide", handlePageHide);
        createdTags.forEach((tag) => head.removeChild(tag));
      };
    }
  }, [type, id, appInstalled]);

  if (loading)
    return (
      <div style={styles.container}>
        <h1 style={styles.heading}>Бүтээгдэхүүн хуваалцах</h1>
        <div style={styles.spinner}></div>
        <p style={styles.text}>
          {appInstalled ? "Апп нээгдэж байна..." : "Түр хүлээнэ үү..."}
        </p>
      </div>
    );

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Апп руу шилжиж байна</h1>
      <p style={styles.text}>
        Хэрэв апп нээгдэхгүй бол доорх линк дээр дарна уу:
      </p>
      <a href={deepLink} style={styles.link}>
        Апп-аар нээх
      </a>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    backgroundColor: "#f9fafb",
    padding: "20px",
    textAlign: "center",
  },
  heading: {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "16px",
    color: "#111827",
  },
  spinner: {
    width: "50px",
    height: "50px",
    border: "5px solid #ddd",
    borderTop: "5px solid #ff0011",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  text: {
    marginTop: "16px",
    fontSize: "16px",
    color: "#374151",
    marginBottom: "16px",
  },
  link: {
    color: "#ff0011",
    textDecoration: "none",
    fontSize: "18px",
    fontWeight: "bold",
    padding: "10px 20px",
    border: "2px solid #ff0011",
    borderRadius: "8px",
  },
};

// CSS animation нэмэх
const styleSheet = document.createElement("style");
styleSheet.innerHTML = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}`;
document.head.appendChild(styleSheet);
